import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, MapPin, Clock, Menu, X } from 'lucide-react';
import { siteSettings } from '../../data/mock';
import { Button } from '../ui/button';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/le-lab', label: 'Le Lab' },
    { path: '/chaussures', label: 'Chaussures' },
    { path: '/textile', label: 'Textile' },
    { path: '/accessoires', label: 'Accessoires' },
    { path: '/nutrition', label: 'Nutrition' },
    { path: '/equipe', label: 'L\'Équipe' },
    { path: '/foulees-vertes-co', label: 'FV & Co' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm">
      {/* Top bar with contact info */}
      <div className="bg-emerald-800 text-white py-2 px-4">
        <div className="max-w-7xl mx-auto flex flex-wrap justify-center md:justify-between items-center gap-2 text-sm">
          <div className="flex items-center gap-6">
            <a href={`tel:${siteSettings.contact.phone}`} className="flex items-center gap-1.5 hover:text-emerald-200 transition-colors">
              <Phone size={14} />
              <span>{siteSettings.contact.phoneDisplay || siteSettings.contact.phone}</span>
            </a>
            <span className="hidden sm:flex items-center gap-1.5">
              <MapPin size={14} />
              <span>Clermont-Ferrand</span>
            </span>
          </div>
          <div className="flex items-center gap-1.5">
            <Clock size={14} />
            <span>Mar-Sam: 10h-13h / 14h-19h</span>
          </div>
        </div>
      </div>

      {/* Main navigation */}
      <div className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center h-16 gap-8">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <img 
                src="/assets/images/logo-header.webp" 
                alt="Foulées Vertes - L'expérience partagée"
                className="h-14 w-auto"
              />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-1 flex-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                    isActive(link.path)
                      ? 'text-emerald-700 bg-emerald-50'
                      : 'text-gray-700 hover:text-emerald-700 hover:bg-gray-50'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            {/* Desktop CTA Button */}
            <Link to="/rendez-vous" className="hidden lg:block">
              <Button className="bg-emerald-700 hover:bg-emerald-800 text-white">
                Prendre RDV
              </Button>
            </Link>

            {/* Mobile menu button */}
            <button
              className="lg:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden border-t border-gray-100 bg-white">
            <nav className="px-4 py-3 space-y-1">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`block px-3 py-2 rounded-md text-base font-medium transition-colors ${
                    isActive(link.path)
                      ? 'text-emerald-700 bg-emerald-50'
                      : 'text-gray-700 hover:text-emerald-700 hover:bg-gray-50'
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/rendez-vous"
                className="block mt-3"
                onClick={() => setMobileMenuOpen(false)}
              >
                <Button className="w-full bg-emerald-700 hover:bg-emerald-800 text-white">
                  Prendre RDV
                </Button>
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
